module.exports = __webpack_public_path__ + "media/images/icons/edit_venue-01fda0264ecc74f044dff874749fde3b.svg";